var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400.338,
    height: 358.204,
    viewBox: "0 0 400.338 358.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-1466 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M294.172,21.067c-3.3,0-6.525,2.083-9.6,6.185-.335.443-34.426,44.622-119.62,70.889-6.232,1.921-13.573,4.385-21.865,5.4-4.586.559-5.669-.4-6.033-1.066a14.987,14.987,0,0,0-13.131-7.79H39.779a15.017,15.017,0,0,0-15,15v5.581c0,3.375-2.379,3.523-3.209,3.588-1.211.094-1.9.145-1.973.151A21.477,21.477,0,0,0,0,140.077v56.24a21.473,21.473,0,0,0,19.6,21.074c.095.007,1.077.079,2.805.215.68.053,2.377.656,2.377,3.656v5.452a15.017,15.017,0,0,0,15,15h6.515a3.6,3.6,0,0,1,3.436,2.91L73.014,350.691c2.286,10.418,12.433,18.58,23.1,18.58h26.873a16.564,16.564,0,0,0,16.668-20.724l-22.748-103.63s-.862-3.2,2.388-3.2h4.63c5.625,0,10.107-3.377,13.088-7.712,1.282-1.865,3.935-1.587,5.375-1.295,8.458,1.716,16.154,3.567,22.563,5.547,85.2,26.32,119.284,70.452,119.613,70.888,3.079,4.105,6.311,6.188,9.6,6.188h0a7.663,7.663,0,0,0,6.963-4.623,17.328,17.328,0,0,0,1.432-7.564V33.253C302.563,21.655,295.573,21.067,294.172,21.067Z",
    transform: "translate(1471 -25.067)",
    fill: "#ABB4BC",
    stroke: "#ABB4BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M366.481,92.88a10,10,0,0,0-16.467,11.352c13.3,19.284,20.323,42.543,20.323,67.264,0,24.629-7.35,48.711-20.694,67.811a10,10,0,1,0,16.395,11.456c15.9-22.752,24.3-50.162,24.3-79.266C390.338,142.7,382.088,115.518,366.481,92.88Z",
    transform: "translate(1471 -25.067)",
    fill: "#ABB4BC",
    stroke: "#ABB4BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M333.616,121.135a10,10,0,0,0-16.467,11.352,68.488,68.488,0,0,1,11.8,39.124,69.331,69.331,0,0,1-12.017,39.442,10,10,0,1,0,16.395,11.456,90.733,90.733,0,0,0,.287-101.374Z",
    transform: "translate(1471 -25.067)",
    fill: "#ABB4BC",
    stroke: "#ABB4BC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.a8a44c53.svg";
export { ForwardRef as ReactComponent };